import { RemoteGetAllInsuranceCompanies } from 'data/usecases/insurance-companies';
import { makeApiUrlInsureCompanies } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllInsuranceCompanies =
  (): RemoteGetAllInsuranceCompanies => {
    return new RemoteGetAllInsuranceCompanies(
      makeApiUrlInsureCompanies(),
      makeAxiosHttpClient(),
    );
  };
